import React, { useEffect, useRef, useState } from 'react';
import './music_toggle.css';
import musicon from '../assets/musicon.png';
import musicoff from '../assets/musicoff.png';
import music from '../assets/Arabian Nights Instrumental.mp3';
import Button from './button';
import { audio_settings, set_audio_setting } from '../audio_settings';

const MusicToggle = (props) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;

    const playMusic = () => {
      if (!audio_settings.music) {
        return;
      }

      const playPromise = audio.play();

      if (playPromise) {
        playPromise
          .then(() => setPlaying(true))
          .catch(() => setPlaying(false));
      }
    };

    const updateAudio = (event) => {
      if (event.detail.name !== 'music') {
        return;
      }

      if (event.detail.value) {
        playMusic();
      } else {
        audio.pause();
        setPlaying(false);
      }
    };

    window.addEventListener('play_music', playMusic);
    window.addEventListener('audio_setting_change', updateAudio);

    return () => {
      window.removeEventListener('play_music', playMusic);
      window.removeEventListener('audio_setting_change', updateAudio);
      audio.pause();
    };
  }, []);

  const toggleMusic = () => {
    set_audio_setting('music', !playing);
  };

  return (
    <Button className={`music_toggle ${props.hidden ? 'music_toggle_hidden' : ''}`} onclick={toggleMusic}>
      <img src={playing ? musicon : musicoff} alt="" />
      <audio ref={audioRef} src={music} loop />
    </Button>
  );
}

export default MusicToggle;
